module.exports = __webpack_public_path__ + "img/document.26cce6d0.svg";